import { useEffect, useState } from "react";
import { useSession } from "../authentications/SessionContext";
// import { nameSearchCRM } from "../DataApi/crm/nameSearchCRM";
import { nameSearchGeneral } from "../DataApi/generalApis/nameSearchGeneral";
import { callButtonGeneral } from "../DataApi/generalApis/callButtonGeneral";

function useListOptions({ model, name, args } = {}) {
  const { sessionInfo } = useSession();
  const { company_id, context } = sessionInfo;

  const [options, setOptions] = useState([]);

  const handleSearch = async ({
    name = "",
    setState = null,
    model = "",
    callButton = false,
    args = [],
    callback = false,
    context = {},
    staticOptions = [],
    isOptions = false,
    pagination = null,
    publicCategId = "",
  } = {}) => {
    if (!model) return;
    if (callButton) {
      let response = await callButtonGeneral({
        company_id,
        method: "get_category_hierarchy",
        model,
        args: [],
        context,
      });
      if (response?.result?.data) {
        // console.log("response", response?.result?.data);
        const mapData = (data) => {
          return data.map((item) => ({
            value: item.id,
            label: item?.name,
            tag_to_show: item?.label || item?.name || "N/A",
            name: item.name,
            checked: item.id == publicCategId ? true : false,
            children:
              item.children && item.children.length > 0
                ? mapData(item.children)
                : [],
          }));
        };

        const customersList = await mapData(response.result?.data);
        const findCheckedItem = (list) => {
          for (const item of list) {
            if (item.checked) {
              return item; // Return the first found checked item
            }
            if (item.children && item.children.length > 0) {
              const foundInChildren = findCheckedItem(item.children);
              if (foundInChildren) {
                return foundInChildren;
              }
            }
          }
          return null; // No checked item found
        };

        setTimeout(() => {
          // Find the label of the item with checked: true
          const checkedItem = findCheckedItem(customersList);
          if (checkedItem) {
            const labelToReplace = checkedItem.tag_to_show;
            // console.log("checkedItem", checkedItem);

            // Select the tag and replace its child node
            const tag = document.querySelector(".tag-item .tag");
            // console.log("get default tag", tag);
            if (tag) {
              tag.childNodes[0].replaceWith(
                document.createTextNode(labelToReplace)
              );
            }
          }
        }, 100);
        // console.log(customersList, "customersList");
        if (callback) {
          callback(customersList || []);
        }

        if (setState) {
          setState(customersList || []);
          // setState((_) => {
          //   const seen = new Set();
          //   const result = [];

          //   const addIfUnique = (obj) => {
          //     const str = JSON.stringify(obj);
          //     if (!seen.has(str)) {
          //       seen.add(str);
          //       result.push(obj);
          //     }
          //   };

          //   const processNode = (node) => {
          //     if (
          //       typeof node.label !== "undefined" &&
          //       typeof node.value !== "undefined"
          //     ) {
          //       addIfUnique(node);
          //       if (node.children && node.children.length > 0) {
          //         node.children.forEach(processNode); // Recursively check and add children
          //       }
          //     }
          //   };

          //   customersList.forEach(processNode);

          //   if (isOptions === true) {
          //     staticOptions?.forEach((item) => {
          //       if (
          //         typeof item.label !== "undefined" &&
          //         typeof item.value !== "undefined"
          //       ) {
          //         addIfUnique(item);
          //       }
          //     });
          //   } else {
          //     staticOptions?.forEach((item) => {
          //       if (
          //         typeof item?.label !== "undefined" &&
          //         typeof item?.value !== "undefined"
          //       ) {
          //         addIfUnique({ label: item.label, value: item.value });
          //       }
          //     });
          //   }

          //   return result;
          // });
        }

        return customersList.length > 0 ? customersList : [];
      }
    } else {
      let response = await nameSearchGeneral({
        model,
        context,
        company_id,
        name,
        args,
        pagination,
      });
      if (response?.result) {
        // console.log("response", response.result);
        const customersList = response.result.map((item) => ({
          label: item[1],
          value: item[0],
        }));
        if (callback) {
          callback(customersList);
        }
        if (setState) {
          setState((_) => {
            const seen = new Set();
            const result = [];

            const addIfUnique = (obj) => {
              const str = JSON.stringify(obj);
              if (!seen.has(str)) {
                seen.add(str);
                result.push(obj);
              }
            };
            customersList.forEach(addIfUnique);
            if (isOptions === true) {
              staticOptions?.forEach((item) => {
                if (
                  typeof item.label !== "undefined" &&
                  typeof item.value !== "undefined"
                ) {
                  addIfUnique(item);
                }
              });
            } else {
              staticOptions?.forEach((item) => {
                if (
                  typeof item?.[1] !== "undefined" &&
                  typeof item?.[0] !== "undefined"
                ) {
                  addIfUnique({ label: item[1], value: item[0] });
                }
              });
            }
            return result;
          });
        }
        return customersList;
      }
      if (callback) {
        callback([]);
      }
      return [];
    }
  };

  const handleCustomSearch = async ({
    name = "",
    model = "",
    callButton = false,
    setState = null,
    callback = null,
    args = [],
    context,
    staticOptions = [],
    isOptions = false,
    pagination = null,
    publicCategId,
  } = {}) =>
    handleSearch({
      name,
      model,
      callButton,
      setState,
      args,
      callback,
      context,
      staticOptions,
      isOptions,
      pagination,
      publicCategId,
    });

  useEffect(() => {
    handleSearch({ name, setState: setOptions, model, args, context });
  }, []);

  return {
    options,
    setOptions,
    handleCustomSearch,
  };
}

export default useListOptions;
